import splitKeyValues from 'src/common/utils/split-prismic-key-vals';
import withProps from 'recompose/withProps';
import get from 'lodash/get';

const withTextOverlay = withProps(props => {
  const extraChoice = splitKeyValues(props.extraChoices);
  if (
    extraChoice &&
    extraChoice.key === 'birthday' &&
    props.productCustomisation[extraChoice.value]
  ) {
    let textOverlay = props.productCustomisation[extraChoice.value];
    if (extraChoice.value === 'month') {
      const monthIndex = props.productCustomisation[extraChoice.value] - 1;
      const slice = get(props, 'drawers.other', [])
        .find(drawer => drawer.sliceType === extraChoice.key);
      const shorthandMonths = get(slice, 'primary.shorthandMonths', '').split(',');
      const shorthandMonth = shorthandMonths[monthIndex];
      if (shorthandMonth) {
        textOverlay = shorthandMonth;
      }
    }
    return { textOverlay };
  }
  return {};
});

export default withTextOverlay;



// WEBPACK FOOTER //
// ./src/client/js/view/components/BreadCrumb/BreadCrumbItem/withTextOverlay.js